import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionItemComponent } from './accordion-item.component';
import { IconModule } from '../icon/icon.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [AccordionItemComponent],
  imports: [CommonModule, IconModule, BrowserAnimationsModule],
  exports: [AccordionItemComponent],
})
export class AccordionItemModule {}
